import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import '@fontsource-variable/inter';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/base.scss';
import './styles/components.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SocketProvider } from './hooks/useSocket';
import { muiTheme } from './styles/muiTheme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <SocketProvider url={process.env.REACT_APP_API_URL}>
    <ThemeProvider theme={muiTheme}>
      <App />
    </ThemeProvider>
  </SocketProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
